import { User as UserIcon, Check } from "lucide-react";

export function PersonaPicker({ personas, selectedId, onChange }) {
  const cardBase = "flex items-center gap-3 rounded-xl border p-2.5 text-left transition w-full";
  const noneActive = selectedId === "";
  return (
    <div className="space-y-2" data-testid="panel-persona-picker">
      <button
        type="button"
        data-testid="panel-persona-none"
        onClick={() => onChange("")}
        className={`${cardBase} ${noneActive ? "border-violet-500/50 bg-violet-500/10" : "border-white/10 bg-white/[0.02] hover:bg-white/[0.05]"}`}
      >
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-800 text-neutral-400">
          <UserIcon size={16} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm text-white">No persona</div>
          <div className="text-[11px] text-neutral-500">Chat as your default self.</div>
        </div>
        {noneActive && <Check size={14} className="text-violet-300" />}
      </button>

      {personas.length === 0 ? (
        <div className="rounded-xl border border-dashed border-white/10 p-3 text-xs text-neutral-500">
          You haven't created any personas yet. Head to Personas to add one.
        </div>
      ) : (
        personas.map((p) => {
          const active = selectedId === p.id;
          const initial = (p.name?.[0] || "?").toUpperCase();
          return (
            <button
              key={p.id}
              type="button"
              data-testid={`panel-persona-${p.id}`}
              onClick={() => onChange(p.id)}
              className={`${cardBase} ${active ? "border-violet-500/50 bg-violet-500/10" : "border-white/10 bg-white/[0.02] hover:bg-white/[0.05]"}`}
            >
              {p.avatar_url ? (
                <img src={p.avatar_url} alt={p.name} className="h-10 w-10 rounded-full object-cover" />
              ) : (
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-violet-500/20 font-display text-sm text-violet-200">
                  {initial}
                </div>
              )}
              <div className="min-w-0 flex-1">
                <div className="text-sm text-white truncate">{p.name}</div>
                {p.description && (
                  <div className="text-[11px] text-neutral-500 truncate">{p.description}</div>
                )}
              </div>
              {active && <Check size={14} className="text-violet-300 shrink-0" />}
            </button>
          );
        })
      )}
    </div>
  );
}
